export default function HelpAndSupport() {
    return <div>Help and Support</div>;
}
